<template>
  <div class="people-fiels-setting-container">
    <div class="people-fiels-setting-body">
      <div class="content">
        <div class="title">
          <span>员工信息字段设置</span>
          <el-button type="primary" icon="el-icon-plus" @click="addGroup">新建组</el-button>
        </div>
        <div class="body">
          <div class="group" v-for="item in groups" :key="item.id">
            <div class="group-title">
              <div class="edit">
                <el-button v-if="item.id !== editId" class="table-name" type="text">{{ item.name }}</el-button>
                <div class="edit-name custom-success-input" v-else>
                  <el-form
                    :ref="item.id"
                    :model="formData.editForm.data"
                    :rules="formData.editForm.rules"
                    @submit.native.prevent
                  >
                    <el-form-item prop="editName">
                      <el-input
                        placeholder="请输入名称"
                        v-model="formData.editForm.data.editName"
                        @keyup.enter.native="saveTableName(item.id)"
                        clearable
                      >
                        <el-button
                          slot="append"
                          icon="el-icon-check"
                          @click="saveTableName(item.id)"
                        ></el-button>
                      </el-input>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="operation">
                  <el-button type="text" icon="el-icon-edit-outline" @click="editTableName(item)"></el-button>
                  <el-button
                    class="delete-button"
                    type="text"
                    icon="el-icon-delete"
                    @click="deleteTable(item)"
                  ></el-button>
                </div>
              </div>
              <div class="add-fiels">
                <el-button type="text" icon="el-icon-plus" @click="addFiels(item.id)">新增字段</el-button>
              </div>
            </div>
            <div class="group-table">
              <el-table
                ref="fielsTable"
                :data="item.columns"
                height="200px"
                :header-cell-style="{'background-color': '#f5f7fa'}"
                :data-id="item.id"
                row-key="id"
              >
                <el-table-column
                  v-for="column in columnData"
                  :prop="column.prop"
                  :key="column.prop"
                  :label="column.label"
                  :resizable="false"
                  :show-overflow-tooltip="true"
                  align="center"
                  :formatter="formatterData"
                ></el-table-column>
                <el-table-column
                  label="操作"
                  :resizable="false"
                  align="center"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <el-button type="text" @click="editRow(scope.row.id, item)">编辑</el-button>
                    <el-button
                      class="delete-button"
                      type="text"
                      @click="deleteRow(scope.row.id, item, scope.$index)"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="none-groups" v-if="groups.length === 0">
            <span>暂无数据</span>
          </div>
        </div>
        <div class="footer">
          <el-button class="cancel" @click="cancelSetting">取消</el-button>
          <el-button type="primary" @click="saveSetting" :disabled="isSave">保存</el-button>
        </div>
      </div>

      <!-- 新增字段弹框 -->
      <div class="add-fiels-dialog">
        <el-dialog
          :title="addFielsDialog.title"
          :visible.sync="addFielsDialog.dialogVisible"
          :close-on-click-modal="false"
          :width="addFielsDialog.dialogWidth"
          @close="addFielsDialogClose"
        >
          <div class="dialog-body">
            <el-form
              class="add-fiels-input"
              ref="addFielsForm"
              :model="formData.dialogForm.data"
              :rules="formData.dialogForm.rules"
              label-position="left"
              label-width="80px"
              @submit.native.prevent
            >
              <el-form-item label="字段名称" prop="name">
                <el-input v-model="formData.dialogForm.data.name" placeholder="请输入字段名" clearable></el-input>
              </el-form-item>
              <el-form-item label="字段类型" prop="type">
                <el-select v-model="formData.dialogForm.data.type" placeholder="请选择字段类型">
                  <el-option
                    v-for="item in selectList.types"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="formData.dialogForm.data.type === '选项'"
                class="opation-content"
                label="选项内容"
              >
                <div class="item">
                  <template v-for="(content, index) in formData.dialogForm.data.content">
                    <el-input
                      class="opation-input"
                      :key="index"
                      placeholder="请输入字段选项"
                      clearable
                      v-model="formData.dialogForm.data.content[index]"
                    >
                      <el-button
                        v-if="index >= 2"
                        slot="append"
                        type="text"
                        @click="deleteOpation(index)"
                      >删除</el-button>
                      <el-button v-else slot="append" type="text">&nbsp;</el-button>
                    </el-input>
                  </template>
                </div>
                <el-button
                  :class="{'no-opation': formData.dialogForm.data.content.length === 0}"
                  type="text"
                  icon="el-icon-plus"
                  @click="addOpation"
                >添加输入选项</el-button>
              </el-form-item>
              <el-form-item label="提示文字" prop="placeholder">
                <el-input
                  v-model="formData.dialogForm.data.placeholder"
                  placeholder="请输入提示文字"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="是否显示" prop="isShow">
                <el-radio-group v-model="formData.dialogForm.data.isShow">
                  <el-radio :label="true">显示</el-radio>
                  <el-radio :label="false">隐藏</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否必填" prop="isFill">
                <el-radio-group v-model="formData.dialogForm.data.isFill">
                  <el-radio :label="true">必填</el-radio>
                  <el-radio :label="false">选填</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="saveFiels">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { UUID } from '@/plugins/common'
import _ from 'lodash'
import Sortable from 'sortablejs'
const columnData = [
  {
    prop: 'name',
    label: '字段名称'
  },
  {
    prop: 'type',
    label: '类型'
  },
  {
    prop: 'isShow',
    label: '是否显示'
  },
  {
    prop: 'isFill',
    label: '是否必填'
  }
]
const types = [
  {
    value: '文本',
    label: '文本'
  },
  {
    value: '日期',
    label: '日期'
  },
  {
    value: '选项',
    label: '选项'
  },
  {
    value: '数字',
    label: '数字'
  }
]
// 默认字段
const defaultFiels = ['姓名', '用户账号', '邮箱', '手机号', '部门名称', '岗位名称', '直属上级', '工号', '用户状态', '在职状态', '是否考勤', '考勤地址设置', '考勤方式', '上班时间', '下班时间', '备注']
export default {
  name: 'peopleFielsSetting',
  data () {
    let commonInput = (rule, value, callback) => {
      if (value.replace(/(^\s*)|(\s*$)/g, '') === '' || !value) {
        return callback(new Error('请输入名称'))
      } else {
        if (value.length > 20) {
          return callback(new Error('只能输入20个字符'))
        } else {
          return callback()
        }
      }
    }
    return {
      // 用来存放所新建的组
      groups: [],
      columnData,
      // 所有表单数据
      formData: {
        // 修改表格名字表单
        editForm: {
          data: {
            editName: ''
          },
          rules: { editName: [{ validator: commonInput, trigger: 'blur' }] }
        },
        // 添加/编辑字段弹框表单
        dialogForm: {
          data: {
            id: '',
            name: '',
            type: '文本',
            placeholder: '',
            isShow: true,
            isFill: false,
            content: []
          },
          rules: {
            name: [
              { validator: commonInput, trigger: 'blur' },
              {
                required: true,
                message: '请输入名称',
                trigger: 'blur'
              }
            ]
          }
        }
      },
      editId: '',
      addFielsDialog: {
        title: '新增字段',
        dialogVisible: false,
        dialogWidth: '23%',
        // 当前添加字段的组的id
        id: '',
        // 是否是编辑页面
        isEdit: false
      },
      selectList: {
        types
      },
      // 排序的元素数组
      sortElemens: [],
      isSave: false
    }
  },
  methods: {
    // 新建组。需要产生一个uuid，只能添加十个
    addGroup () {
      if (this.groups.length < 10) {
        this.groups.push({
          id: UUID.create(),
          name: '新建组',
          columns: []
        })
      } else {
        this.$message({
          message: '最多只能添加十组',
          type: 'warning'
        })
      }
    },
    editRow (id, item) {
      let i = item.columns.findIndex(e => e.id === id)
      this.addFielsDialog.title = '编辑字段'
      this.addFielsDialog.isEdit = true
      // 防止同步修改数据
      let params = {...item.columns[i]}
      this.addFielsDialog.id = item.id
      this.addFielsDialog.dialogVisible = true
      this.$nextTick(() => {
        i !== -1 && (this.formData.dialogForm.data = params)
      })
    },
    // 删除组中字段
    deleteRow (id, item, index) {
      this.$confirm(
        '<p class="delte-table">(删除字段后相关数据不可恢复，请谨慎删除)<p>',
        '确定要删除字段吗？',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          center: true,
          customClass: 'deleMessageBox-custom-people',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => {
          let i = item.columns.findIndex(e => e.id === id)
          i !== -1 && item.columns.splice(i, 1)
        })
        .catch(() => {})
    },
    // 编辑表格名字
    editTableName (item) {
      this.formData.editForm.data.editName = item.name || ''
      this.editId = item.id
    },
    // 删除(组)表格
    deleteTable (item) {
      this.$confirm(
        '<p class="delte-group">本组内容均会被删除，是否确定删除组？<p>',
        '',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          center: true,
          customClass: 'deleMessageBox-custom-people',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => {
          let index = this.groups.findIndex(e => e.id === item.id)
          this.groups.splice(index, 1)
          // 解除拖拽绑定
          this.sortElemens[index].destroy()
          this.sortElemens.splice(index, 1)
        })
        .catch(() => {})
    },
    // 保存表格名字
    saveTableName (id) {
      this.$refs[id][0].validate(v => {
        if (v) {
          let index = this.groups.findIndex(e => e.id === this.editId)
          index !== -1 &&
            (this.groups[index].name = this.formData.editForm.data.editName)
          this.editId = ''
          this.formData.editForm.data.editName = ''
        } else {
          return false
        }
      })
    },
    // 新增字段
    addFiels (id) {
      this.addFielsDialog.id = id
      this.addFielsDialog.dialogVisible = true
    },
    // 删除字段选项
    deleteOpation (i) {
      this.formData.dialogForm.data.content.splice(i, 1)
    },
    // 添加选项
    addOpation () {
      this.formData.dialogForm.data.content.push('')
    },
    // 保存字段
    saveFiels () {
      this.$refs.addFielsForm.validate(v => {
        if (v) {
          let i = this.groups.findIndex(e => e.id === this.addFielsDialog.id)
          let params = { ...this.formData.dialogForm.data }
          let isEmpty = false
          params.type === '选项' && (isEmpty = params.content.filter(e => e.replace(/(^\s*)|(\s*$)/g, '') !== '').length !== params.content.length)
          if (!isEmpty) {
            // 新建
            if (params.id === '') {
              params.id = UUID.create()
            } else {
              params.type !== '选项' && (params.content = [])
            }
            if (i !== -1) {
              let tabIndex = this.groups[i].columns.findIndex(e => e.id === params.id)
              // 添加
              if (tabIndex === -1) {
                // 校验名字是否重复
                let isRepet = false
                // 首先校验是否与默认字段重复
                if (defaultFiels.indexOf(this.formData.dialogForm.data.name.replace(/(^\s*)|(\s*$)/g, '')) === -1) {
                  this.groups.forEach(item => {
                    if (item.columns.length > 0) {
                      for (let i = 0; i < item.columns.length; i++) {
                        if (item.columns[i].name.replace(/(^\s*)|(\s*$)/g, '') === this.formData.dialogForm.data.name.replace(/(^\s*)|(\s*$)/g, '')) {
                          isRepet = true
                          break
                        }
                      }
                    }
                  })
                  if (!isRepet) {
                    this.groups[i].columns.push(params)
                  } else {
                    return this.$message.error('字段名称不能重复')
                  }
                } else {
                  return this.$message.error('已有预留字段，不能重复')
                }
              } else {
                this.$set(this.groups[i].columns, tabIndex, params)
              }
              this.addFielsDialog.dialogVisible = false
            }
          } else {
            return this.$message.error('请输入字段选项的值')
          }
        } else {
          return false
        }
      })
    },
    // 取消保存
    cancel () {
      this.addFielsDialog.dialogVisible = false
    },
    // 弹框关闭之前
    addFielsDialogClose () {
      this.addFielsDialog.id = ''
      this.formData.dialogForm.data.id = ''
      this.$refs.addFielsForm.resetFields()
    },
    // 格式化是否隐藏是否必填
    formatterData (row, column, cellValue) {
      if (column.property === 'isShow') {
        return cellValue ? '显示' : '隐藏'
      } else if (column.property === 'isFill') {
        return cellValue ? '必填' : '选填'
      }
      return cellValue
    },
    // 表格行拖拽
    rowDrop (i) {
      this.$nextTick(() => {
        const tbody = document.querySelectorAll('.el-table__body-wrapper tbody')[i]
        let _self = this
        _self.sortElemens.push(
          Sortable.create(tbody, {
            onEnd (e) {
              if (e.oldIndex !== e.newIndex) {
                let i = _self.groups.findIndex(item => item.id === e.path[3].getAttribute('data-id'))
                _self.groups[i].columns.splice(e.newIndex, 0, _self.groups[i].columns.splice(e.oldIndex, 1)[0])
              }
            },
            // 拖拽时的样式
            ghostClass: 'ghost-class',
            // 如果设置为true，则页面（或可排序区域）在到达边缘时滚动。
            scroll: true,
            // 鼠标必须靠近边缘多少px才能开始滚动
            scrollSensitivity: 30,
            // 滚动速度
            scrollSpeed: 10
          })
        )
      })
    },
    // 保存设置
    saveSetting () {
      // 给表格中的数据添加sort
      this.isSave = true
      let params = [...this.groups]
      params.forEach(item => {
        if (item.columns.length > 0) {
          for (let i = 0; i < item.columns.length; i++) {
            item.columns[i].sort = i + 1
          }
        }
      })
      this.$axios.post('/auth-api/customcolumns', params).then(res => {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.getSettingInfo().then(() => {
          this.isSave = false
        })
      })
    },
    // 取消设置
    cancelSetting () {
      this.$router.go(-1)
    },
    // 获取设置信息
    getSettingInfo () {
      return new Promise((resolve, reject) => {
        this.$axios.get('/auth-api/customcolumns').then(res => {
          this.groups = res.data
          this.$nextTick(() => {
            resolve()
          })
        })
      })
    }
  },
  created () {
    this.getSettingInfo().then(() => {
      this.isSave = false
    })
  },
  mounted () {
    this.addFielsDialog.dialogWidth = document.body.clientWidth > 1500 ? '23%' : '30%'
    window.onresize = _.debounce(e => {
      this.addFielsDialog.dialogWidth = document.body.clientWidth > 1500 ? '23%' : '33%'
    }, 10)
  },
  watch: {
    'formData.dialogForm.data.type': function (newVal, oldVal) {
      if (newVal === '选项') {
        if (this.addFielsDialog.isEdit) {
          if (this.formData.dialogForm.data.content.length === 0) {
            this.formData.dialogForm.data.content = ['', '']
          }
          this.addFielsDialog.isEdit = false
        } else {
          this.formData.dialogForm.data.content = ['', '']
        }
      }
    },
    'groups' (val) {
      if (val.length > 0) {
        val.forEach((m, n) => {
          this.rowDrop(n)
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  // 自定义弹框样式
  .deleMessageBox-custom-people {
    padding-bottom: 10px;
    width: 380px;

    .el-message-box__header {
      .el-message-box__title {
        span {
          font-size: 14px;
        }
      }
    }

    .el-button--small,
    .el-button--small.is-round {
      padding: 7px 15px;
    }

    .el-message-box__btns {
      text-align: center;
      margin-bottom: 10px;

      & > .el-button--default:first-child {
        color: #409eff;
        border: 1px solid #409eff;
        margin-right: 20px;
      }
    }

    .el-message-box__message {
      .delte-table {
        font-size: 14px;
        text-align: center;
        margin-bottom: 10px;
        color: #aaa;
      }

      .delte-group {
        margin-bottom: 10px;
      }
    }
  }

  // 覆盖原有的弹框样式
  #app {
    .add-fiels-dialog {
      .el-dialog {
        padding: 0 10px;

        .el-dialog__header {
          text-align: center;
          background-color: #fff;
          border-bottom: 1px solid #edeeee;
        }

        .el-dialog__body {
          padding: 20px 50px 10px 50px;

          .opation-content {
            margin-bottom: 0;

            .el-form-item__content {
              .no-opation {
                margin-bottom: 12px;
              }

              .item {
                max-height: 185px;
                overflow: auto;

                .el-input-group__append {
                  background-color: #fff;
                  border: none;
                  color: #409eff;
                  padding-left: 40px;
                }

                .el-input-group--append .el-input__inner,
                .el-input-group__prepend {
                  border-radius: 4px;
                }

                & .opation-input:not(:last-child) {
                  margin-bottom: 10px;
                }
              }
            }
          }

          .el-select {
            width: 100%;
          }
        }

        .el-dialog__footer {
          .dialog-footer {
            text-align: center;

            .el-button:first-child {
              border-color: #409eff;
              color: #409eff;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }

  .add-fiels-input {
    .el-form-item.is-success .el-input__inner {
      border-color: #dcdfe6;
    }

    .el-form-item.is-success .el-input__inner:hover {
      border-color: #c0c4cc;
    }

    .el-form-item.is-success .el-input__inner:focus,
    .el-form-item.is-success .el-textarea__inner,
    .el-form-item.is-success .el-textarea__inner:focus {
      border-color: #409eff;
      outline: 0;
    }
  }
  .people-fiels-setting-container {
    height: 100%;
    padding: 10px;

    div,
    span,
    p,
    label {
      font-size: 12px;
    }

    .ghost-class {
      background-color: #eee;
    }

    .delete-button {
      color: red;
    }

    .el-message-box--center {
      padding-bottom: 0;
    }

    .people-fiels-setting-body {
      background: #fff;
      box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
      border-radius: 4px 0;
      height: 100%;

      .content {
        height: 100%;
        padding: 10px;

        .title {
          position: relative;
          border-bottom: 1px solid #edeeee;
          height: 42px;
          line-height: 42px;

          & > span {
            font-size: 14px;
          }

          .el-button--mini {
            padding: 7px 15px 7px 12px;
            position: absolute;
            right: 0;
          }
        }

        .body {
          height: calc(100% - 85px);
          overflow: auto;
          position: relative;

          .group {
            .group-title {
              padding: 10px 10px 12px;
              position: relative;

              .edit {
                width: calc(100% - 80px);
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                height: 30px;

                .table-name {
                  margin-right: 15px;
                }

                .edit-name {
                  width: 140px;
                  margin-right: 15px;

                  .el-input-group__append {
                    background-color: #409eff;
                    border-color: #409eff;
                    color: #fff;
                    padding: 0 12px;
                  }
                }
              }

              .add-fiels {
                position: absolute;
                right: 10px;
                top: 10px;
              }
            }
          }

          .none-groups {
            position: absolute;
            top: 47%;
            left: 48%;
            color: #999;
          }
        }

        .footer {
          text-align: center;
          height: 50px;
          line-height: 50px;
          width: 100%;

          .cancel {
            border-color: #409eff;
            color: #409eff;
            margin-right: 10px;
          }
        }
      }

      .add-fiels-dialog {
        .el-dialog__wrapper {
          .el-dialog {
            .el-dialog__header {
              text-align: center;
              background-color: #fff;
              border-bottom: #edeeee;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/users/people-fiels-setting.vue